import { PayeeSearchWithDefaultRequestModel } from '@alcon-db-models/PayeeSearchWithDefaultRequestModel';
import { Directive } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import { FilterDescriptor } from '@progress/kendo-data-query';
import { AppUxService } from '@services/app-ux.service';
import { PayeeSelectSearchService } from '@services/payee-select-search.service';
import { SelectSearchBindingBaseDirective } from './select-search-binding.base.directive';

@Directive({
  selector: '[payeeSelectSearchBinding]'
})
export class PayeeSelectSearchBindingDirective extends SelectSearchBindingBaseDirective {

  constructor(payeeSelectSearchService: PayeeSelectSearchService, grid: GridComponent, appUxService: AppUxService) {
    super(payeeSelectSearchService, grid, appUxService);
  }

  public getSearchRequest(doIgnorePagination: boolean = false): PayeeSearchWithDefaultRequestModel {

    this.beforeBind.emit(null);

    const filters: FilterDescriptor[] = this.state.filter?.filters as FilterDescriptor[];

    const getValue = function(col:string) {
      let descriptor: FilterDescriptor;
      return (descriptor = filters?.find(x => x.field == col) as FilterDescriptor) ? descriptor?.value : null
    };

    const request = {
      personID: null,
      take: doIgnorePagination ? null : this.state.take,
      skip: doIgnorePagination ? 0 : this.state.skip,
      sortColumn: this.state.sort?.[0]?.dir ? this.state.sort?.[0]?.field : null,
      sortAscending: this.state.sort?.[0]?.dir ? this.state.sort[0].dir != 'desc' : null,
      customerCodeOrName: getValue('customerCodeOrName'),
      customerID: getValue('customerID'),
      prependPayeeCustomerID:  getValue('prependPayeeCustomerID')
    };

    return (request);
  }



}

